export default "__VITE_ASSET__f413e8f2__"